import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { remitosApi, notasEnvioApi } from '../api/remitos'
import { salidasApi } from '../api/salidas'
import EstadoBadgeRemito from '../components/EstadoBadgeRemito'
import EstadoVigenteBadge from '../components/EstadoVigenteBadge'
import Boton from '../components/Boton'
import ModalCompartirCliente from '../components/ModalCompartirCliente'
import BotonEncuestaSatisfaccion from '../components/BotonEncuestaSatisfaccion'
import Modal from '../components/Modal'
import AvisosCard from '../components/avisos/AvisosCard'
import AndreaniHistorial from '../components/AndreaniHistorial'
import EnvioParcialCard from '../components/EnvioParcialCard'
import { fmtFecha, fmtFechaHora, fmtMonto } from '../utils/fecha'
import { abrirArchivoEnPestana } from '../utils/descargar'
import api from '../api/client'
import { colors, font, text, space, sx } from '../design/tokens'

const FONT_MONO = 'ui-monospace, "SF Mono", Menlo, monospace'

const ENTREGA_CFG = {
  entregado:    { bg: '#dcfce7', color: '#166534', label: 'Entregado' },
  no_entregado: { bg: '#fee2e2', color: '#991b1b', label: 'No entregado' },
  reagendado:   { bg: '#e0e7ff', color: '#3730a3', label: 'Reagendado' },
  pendiente:    { bg: '#f1f5f9', color: '#64748b', label: 'Pendiente' },
}

function Row({ label, children, mono = false, last = false }) {
  return (
    <div style={last ? st.rowLast : st.row}>
      <span style={st.rowLabel}>{label}</span>
      <span style={{ ...st.rowValue, ...(mono ? st.rowMono : {}) }}>{children}</span>
    </div>
  )
}

export default function RemitoDetallePage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [remito, setRemito] = useState(null)
  const [entregas, setEntregas] = useState([])
  const [loading, setLoading] = useState(true)
  const [imgModal, setImgModal] = useState(null)
  const [anulando, setAnulando] = useState(false)
  const [motivoAnular, setMotivoAnular] = useState('')
  const [showAnular, setShowAnular] = useState(false)
  // Caso de entrega: el remito se entregó pero llegó con roturas / faltantes /
  // mal estado. Relato + selección de productos → reposición solo-remito.
  const [showCaso, setShowCaso] = useState(false)
  const [casoDetalle, setCasoDetalle] = useState('')
  const [casoSel, setCasoSel] = useState({}) // articulo_id → cantidad a reponer
  const [casoEnviando, setCasoEnviando] = useState(false)
  const [casoError, setCasoError] = useState('')
  // Devolución por producto defectuoso (Martin, 2 oct 2026): la otra salida del caso.
  const [casoTipo, setCasoTipo] = useState('reposicion')
  const [casoRetiro, setCasoRetiro] = useState(true)
  const [errorAnular, setErrorAnular] = useState('')
  const [imprimiendoNe, setImprimiendoNe] = useState(null)
  const [reimprisiendoNe, setReimprisiendoNe] = useState(null)
  const [imprimiendoMasivo, setImprimiendoMasivo] = useState(false)
  const [msgNe, setMsgNe] = useState('')
  const [confirmando, setConfirmando] = useState(false)
  const [cambiandoTransporte, setCambiandoTransporte] = useState(false)
  const [msgAccion, setMsgAccion] = useState('')
  const [errorAccion, setErrorAccion] = useState('')
  const [imprimiendoRemito, setImprimiendoRemito] = useState(false)
  const [showReimprimir, setShowReimprimir] = useState(false)
  const [motivoReimp, setMotivoReimp] = useState('')
  const [errorReimp, setErrorReimp] = useState('')
  const [showCompartir, setShowCompartir] = useState(false)
  const [andreani, setAndreani] = useState({ generando: false, error: '' })
  // Bebidas sin contenido (ml) en el maestro: el backend avisa ANTES de generar
  // la orden (sus cajas se armaron como 750). El operador decide (sug #99).
  const postAndreaniConAviso = async (url, body) => {
    try {
      return await api.post(url, body)
    } catch (err) {
      const aviso = err.response?.status === 422 && err.response?.data?.errors?.sin_contenido?.[0]
      if (!aviso) throw err
      if (!window.confirm(aviso)) {
        const e = new Error('cancelado')
        e.response = { data: { message: 'Generación cancelada: revisá el contenido (ml) de esos artículos en el maestro.' } }
        throw e
      }
      return api.post(url, { ...body, confirmar_sin_contenido: true })
    }
  }
  // Valor declarado que asegura Andreani (10 oct 2026): precargado con el del remito.
  const [valorAndreani, setValorAndreani] = useState(null)
  // Fecha de entrega estimada: editable en cualquier etapa (sug #51).
  const [editandoFecha, setEditandoFecha] = useState(false)
  const [fechaEdit, setFechaEdit] = useState('')
  // Horario de la entrega, escrito a gusto (Martin, 28 ago 2026): "12 a 18",
  // "después de las 14". Va impreso en el remito tal como se tipea.
  const [horarioEdit, setHorarioEdit] = useState('')
  const [guardandoFecha, setGuardandoFecha] = useState(false)

  const handleDeshacerParte = async (ne) => {
    if (!window.confirm(`¿Deshacer la parte ${ne.numero_ne}? Lo que llevaba vuelve a quedar pendiente.`)) return
    try {
      await notasEnvioApi.anularParte(ne.id)
      setMsgNe(`Parte ${ne.numero_ne} deshecha.`)
      cargar()
    } catch (err) {
      setMsgNe('Error: ' + (err.response?.data?.message || 'no se pudo deshacer la parte.'))
    }
  }

  const cargar = async () => {
    setLoading(true)
    try {
      const [rResult, eResult] = await Promise.allSettled([
        remitosApi.obtener(id),
        remitosApi.entregas(id),
      ])
      if (rResult.status === 'fulfilled') setRemito(rResult.value.data)
      else { navigate('/remitos'); return }
      if (eResult.status === 'fulfilled') setEntregas(eResult.value.data || [])
    } finally { setLoading(false) }
  }

  useEffect(() => { cargar() }, [id])

  const handleAnular = async () => {
    if (!motivoAnular.trim()) { setErrorAnular('El motivo es obligatorio.'); return }
    setAnulando(true)
    setErrorAnular('')
    try {
      const { data } = await remitosApi.anular(id, motivoAnular)
      await cargar()
      setShowAnular(false)
      setMotivoAnular('')
      // Remito que existe en Presea: la anulación queda pedida hasta verlo anulado allá.
      if (data?.anulacion === 'pedida') { setErrorAccion(''); setMsgAccion(data.mensaje_anulacion) }
    } catch (err) {
      setErrorAnular(err.response?.data?.message || 'Error al anular.')
    } finally { setAnulando(false) }
  }

  const handleAbrirCaso = async () => {
    if (!casoDetalle.trim()) { setCasoError('Contá qué pasó con la entrega.'); return }
    const items = Object.entries(casoSel)
      .map(([aid, cant]) => ({ articulo_id: parseInt(aid, 10), cantidad: parseInt(cant, 10) || 0 }))
      .filter(i => i.cantidad > 0)
    setCasoEnviando(true); setCasoError('')
    if (casoTipo === 'devolucion') {
      try {
        const { data } = await api.post(`/remitos/${id}/abrir-devolucion`, {
          detalle: casoDetalle.trim(), con_retiro: casoRetiro,
        })
        navigate(`/casos/${data.caso.id}`)
      } catch (err) {
        const errs = err.response?.data?.errors
        setCasoError(errs ? Object.values(errs).flat().join(' ') : (err.response?.data?.message || 'No se pudo abrir la devolución.'))
        setCasoEnviando(false)
      }
      return
    }
    try {
      const { data } = await api.post(`/remitos/${id}/abrir-caso`, { detalle: casoDetalle.trim(), items })
      const repo = data.caso?.reposicion_nota_venta
      setMsgAccion(data.advertencia
        ? `Caso #${data.caso.id} abierto — ⚠ ${data.advertencia}`
        : (repo
          ? `Caso #${data.caso.id} abierto. Reposición ${repo.numero_lgr} enviada a Presea: al confirmarse, el remito nuevo aparece en Asignaciones.`
          : `Caso #${data.caso.id} abierto (sin reposición).`))
      setShowCaso(false); setCasoDetalle(''); setCasoSel({}); setCasoTipo('reposicion')
      await cargar()
    } catch (err) {
      setCasoError(err.response?.data?.message || 'No se pudo abrir el caso.')
    } finally { setCasoEnviando(false) }
  }

  const handleImprimir = async (neId) => {
    setImprimiendoNe(neId); setMsgNe('')
    try {
      await notasEnvioApi.imprimir(neId)
      setMsgNe('Impresión registrada correctamente.')
      await cargar()
    } catch (err) {
      setMsgNe(err.response?.data?.message || 'Error al registrar impresión.')
    } finally { setImprimiendoNe(null) }
  }

  // Reimpresión de NE: inmediata con motivo obligatorio (mismo criterio que el
  // remito T90) — se asienta la huella y se abre el PDF al instante.
  const handleReiprimir = async (neId) => {
    const motivo = window.prompt('Motivo de la reimpresión (queda registrado):')
    if (motivo === null) return
    if (motivo.trim().length < 3) { setMsgNe('El motivo es obligatorio (mínimo 3 caracteres).'); return }
    setReimprisiendoNe(neId); setMsgNe('')
    try {
      await notasEnvioApi.reimprimir(neId, motivo.trim())
      await abrirArchivoEnPestana(`/notas-envio/${neId}/pdf`)
      setMsgNe('Reimpresión registrada — se abrió el PDF.')
      await cargar()
    } catch (err) {
      setMsgNe(err.response?.data?.message || err.message || 'Error al reimprimir.')
    } finally { setReimprisiendoNe(null) }
  }

  const handleImprimirMasivo = async () => {
    setImprimiendoMasivo(true); setMsgNe('')
    try {
      const { data } = await remitosApi.imprimirNesMasivo(id)
      abrirPdf(data)
      await cargar()
      setMsgNe('Impresión masiva registrada — se abrió el PDF combinado.')
    } catch (err) {
      setMsgNe((await mensajeErrorBlob(err)) || 'No se pudo imprimir el lote.')
    } finally { setImprimiendoMasivo(false) }
  }

  const handleConfirmar = async () => {
    setConfirmando(true); setErrorAccion('')
    try {
      await remitosApi.confirmar(id)
      await cargar()
      setMsgAccion('Remito confirmado — pasa a logística.')
      // Al confirmar, ofrecer compartir los comprobantes con el cliente.
      // El operador decide qué incluir y por dónde (mail / WhatsApp).
      setShowCompartir(true)
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'Error al confirmar.')
    } finally { setConfirmando(false) }
  }

  const handleMarcarRetirado = async () => {
    if (!window.confirm('¿El cliente ya retiró el pedido en depósito? Esto marca el remito como entregado.')) return
    setConfirmando(true); setErrorAccion('')
    try {
      await remitosApi.marcarRetirado(id)
      await cargar()
      setMsgAccion('Remito marcado como retirado.')
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'Error al marcar retirado.')
    } finally { setConfirmando(false) }
  }

  // Una anulación por error se deshace, pero solo si Presea todavía tiene el
  // remito (Martin, 29 ago 2026): el backend lo consulta en vivo y rechaza si
  // no existe, si figura "ANUL." o si el WS no responde.
  const handleRevertirAnulacion = async () => {
    if (!window.confirm('¿Revertir la anulación? Se verifica en Presea que el remito exista y no esté anulado; si está, vuelve a su estado anterior.')) return
    setConfirmando(true); setErrorAccion(''); setMsgAccion('')
    try {
      const { data } = await remitosApi.revertirAnulacion(id)
      await cargar()
      setMsgAccion(`Anulación revertida — el remito volvió a "${data?.estado || 'su estado anterior'}".`)
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'No se pudo revertir la anulación.')
    } finally { setConfirmando(false) }
  }

  // Anulación pedida (Martin, 15 sep 2026): LGR la aprueba cuando Presea
  // muestra el remito anulado. El backend consulta en vivo; el cron también.
  const handleVerificarAnulacion = async () => {
    setConfirmando(true); setErrorAccion(''); setMsgAccion('')
    try {
      await remitosApi.verificarAnulacion(id)
      await cargar()
      setMsgAccion('Presea muestra el remito anulado: anulación aprobada.')
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'No se pudo verificar la anulación.')
    } finally { setConfirmando(false) }
  }

  const handleResolverAnticipada = async (a, estado) => {
    if (estado === 'rechazada' && !window.confirm(`¿Rechazar? El ${a.numero} sale el día pactado con el cliente.`)) return
    setConfirmando(true); setErrorAccion(''); setMsgAccion('')
    try {
      await salidasApi.resolverAnticipada(a.id, estado)
      await cargar()
      setMsgAccion(estado === 'aprobada'
        ? 'Autorizado: logística ya lo puede entregar antes. Le avisamos a quien lo pidió.'
        : 'Rechazado: sale el día pactado. Le avisamos a quien lo pidió.')
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'No se pudo resolver el pedido.')
    } finally { setConfirmando(false) }
  }

  const handleCancelarAnulacion = async () => {
    if (!window.confirm('¿Cancelar el pedido de anulación? El remito sigue vigente.')) return
    setConfirmando(true); setErrorAccion(''); setMsgAccion('')
    try {
      await remitosApi.cancelarAnulacion(id)
      await cargar()
      setMsgAccion('Pedido de anulación cancelado: el remito sigue vigente.')
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'No se pudo cancelar el pedido.')
    } finally { setConfirmando(false) }
  }

  // Espejo del "revertir entrega" de un envío a domicilio, pero para el retiro
  // (que no tiene salida ni parada): la mercadería volvió al local.
  const handleDeshacerRetiro = async () => {
    if (!window.confirm('¿Deshacer el retiro? Confirmás que la mercadería está de vuelta en el local. El remito vuelve a "confirmado" y se puede volver a marcar retirado o anular.')) return
    setConfirmando(true); setErrorAccion('')
    try {
      await remitosApi.deshacerRetiro(id)
      await cargar()
      setMsgAccion('Retiro deshecho — el remito volvió a confirmado.')
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'Error al deshacer el retiro.')
    } finally { setConfirmando(false) }
  }

  // La sucursal ya tiene el remito y la mercadería listos para entregar →
  // se le avisa por mail al cliente que puede pasar a buscar el pedido.
  const handleDisponibleRetiro = async () => {
    if (!window.confirm('¿La sucursal ya tiene el remito y la mercadería listos? Se le avisa al cliente por mail que puede pasar a retirar.')) return
    setConfirmando(true); setErrorAccion('')
    try {
      const res = await remitosApi.disponibleRetiro(id)
      await cargar()
      setMsgAccion(`Marcado como disponible — ${res.data?.aviso_detalle || 'listo'}.`)
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'Error al marcar disponible.')
    } finally { setConfirmando(false) }
  }

  // Cambiar la modalidad de entrega de un remito ya emitido (25 ago 2026,
  // caso 1700007895): el cliente prefiere pasar a buscar un remito que iba
  // por reparto → se lo saca del viaje y entra a la lista de retiros de la
  // sucursal. Antes se lo asignaba a un "fletero" llamado "retira sucursal
  // callao" y LGR armaba una salida.
  const [modalRetiro, setModalRetiro] = useState(false)
  const [modalFraude, setModalFraude] = useState(false)
  const [motivoFraude, setMotivoFraude] = useState('')
  const [sucursales, setSucursales] = useState([])
  const [sucursalElegida, setSucursalElegida] = useState('')
  const [motivoRetiro, setMotivoRetiro] = useState('')
  const abrirPasarARetiro = () => {
    setErrorAccion(''); setMotivoRetiro('')
    if (sucursales.length === 0) {
      api.get('/sucursales-retiro').then(({ data }) => { setSucursales(data || []); setSucursalElegida(data?.[0]?.id || '') }).catch(() => {})
    }
    setModalRetiro(true)
  }
  const handlePasarARetiro = async () => {
    if (!sucursalElegida) return
    setConfirmando(true); setErrorAccion('')
    try {
      await remitosApi.pasarARetiro(id, sucursalElegida, motivoRetiro)
      setModalRetiro(false)
      await cargar()
      setMsgAccion('El remito pasó a retiro en sucursal. Reimprimilo: el papel ahora dice "RETIRA EN SUCURSAL".')
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'Error al pasar a retiro.')
    } finally { setConfirmando(false) }
  }
  const handleFraudeTransito = async () => {
    if (!motivoFraude.trim()) return
    setConfirmando(true); setErrorAccion('')
    try {
      await remitosApi.fraudeTransito(id, motivoFraude.trim())
      setModalFraude(false)
      await cargar()
      setMsgAccion('Marcado como fraude: salió de Asignaciones y queda esperando que vuelva la mercadería. El cliente pasó a la lista negra.')
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'No se pudo marcar el fraude.')
    } finally { setConfirmando(false) }
  }
  const handleMercaderiaDevuelta = async () => {
    if (!window.confirm('¿La mercadería ya está en el depósito?')) return
    setConfirmando(true); setErrorAccion(''); setMsgAccion('')
    try {
      await remitosApi.mercaderiaDevuelta(id)
      await cargar()
      setMsgAccion('Recibida. Falta la NC / Devolución de la venta en Presea para que vuelva al stock (le avisamos a quien la procesó).')
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'No se pudo registrar la devolución.')
    } finally { setConfirmando(false) }
  }
  const handleVolverAReparto = async () => {
    if (!window.confirm('¿Volver a reparto? El remito deja de ser retiro en sucursal; después hay que asignarle zona y salida, y reimprimirlo.')) return
    setConfirmando(true); setErrorAccion('')
    try {
      await remitosApi.volverAReparto(id)
      await cargar()
      setMsgAccion('El remito volvió a reparto. Asignale zona y salida, y reimprimilo.')
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'Error al volver a reparto.')
    } finally { setConfirmando(false) }
  }

  const handleEnviarPresea = async () => {
    setConfirmando(true); setErrorAccion('')
    try {
      await remitosApi.generarPresea(id)
      await cargar()
      setMsgAccion('Enviado a Presea — al volver el número, el remito queda confirmado y pasa a logística.')
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'Error al enviar a Presea.')
    } finally { setConfirmando(false) }
  }

  const handleCambiarTransporte = async () => {
    const nuevo = remito.transporte === 80 ? 90 : 80
    if (!window.confirm(`¿Cambiar a Transporte ${nuevo}? ${nuevo === 90 ? 'El remito pasará a entrega única (sin NE).' : 'El remito pasará a entrega múltiple (con NE).'}`)) return
    setCambiandoTransporte(true); setErrorAccion('')
    try {
      const { data } = await remitosApi.cambiarTransporte(id, nuevo)
      await cargar()
      setMsgAccion(data?.autorizacion_pendiente
        ? '📨 Solicitud enviada a administración por Telegram — cuando la autoricen, el remito pasa a T80 solo.'
        : `Transporte cambiado a T${nuevo}.`)
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'Error al cambiar transporte.')
    } finally { setCambiandoTransporte(false) }
  }

  // Errores de respuestas blob vienen como Blob: hay que leerlos como texto/JSON.
  const mensajeErrorBlob = async (err) => {
    const data = err.response?.data
    if (data instanceof Blob) {
      try { return JSON.parse(await data.text()).message } catch { return null }
    }
    return data?.message || null
  }

  const abrirPdf = (data) => {
    const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
    window.open(url, '_blank')
  }

  const handleGuardarFecha = async () => {
    setGuardandoFecha(true); setErrorAccion('')
    try {
      await api.put(`/remitos/${id}/fecha-entrega`, {
        fecha_entrega_est: fechaEdit || null,
        horario_entrega: fechaEdit ? (horarioEdit.trim() || null) : null,
      })
      setEditandoFecha(false)
      const yaImpreso = (remito?.impresiones_count || 0) > 0
      setMsgAccion(yaImpreso
        ? 'Fecha de entrega actualizada. El remito ya estaba impreso: reimprimilo para que el papel muestre la fecha nueva.'
        : 'Fecha de entrega actualizada.')
      await cargar()
    } catch (err) {
      setErrorAccion(err.response?.data?.message || 'No se pudo actualizar la fecha de entrega.')
    } finally { setGuardandoFecha(false) }
  }

  const handleImprimirRemito = async () => {
    setImprimiendoRemito(true); setMsgAccion(''); setErrorAccion('')
    try {
      const { data } = await remitosApi.imprimir(id)
      abrirPdf(data)
      await cargar()
      setMsgAccion('Remito impreso — impresión registrada.')
    } catch (err) {
      setErrorAccion((await mensajeErrorBlob(err)) || 'No se pudo imprimir el remito.')
    } finally { setImprimiendoRemito(false) }
  }

  const handleReimprimirRemito = async () => {
    if (!motivoReimp.trim()) { setErrorReimp('El motivo es obligatorio.'); return }
    setImprimiendoRemito(true); setErrorReimp('')
    try {
      const { data } = await remitosApi.reimprimir(id, motivoReimp.trim())
      abrirPdf(data)
      await cargar()
      setShowReimprimir(false)
      setMotivoReimp('')
      setMsgAccion('Reimpresión registrada con el motivo indicado.')
    } catch (err) {
      setErrorReimp((await mensajeErrorBlob(err)) || 'No se pudo reimprimir.')
    } finally { setImprimiendoRemito(false) }
  }

  if (loading) return <p style={{ color: '#64748b', padding: 20 }}>Cargando remito...</p>
  if (!remito) return null

  const es80 = remito.transporte === 80
  // Envío parcial: T80 que se despacha de a partes (EnvioParcialCard), sin planilla.
  const esParcial = !!remito.envio_parcial
  const nv = remito.nota_venta
  const esLibre = !nv  // remito sin NV: confirma vía Presea, no con el botón manual
  const facturas = (nv?.comprobantes || []).filter(c => c.tipo === 'factura')
  const pagos = nv?.pagos || []

  return (
    <div style={st.wrap}>
      {/* Toolbar sticky: breadcrumb + estado + acciones siempre visibles */}
      <div style={st.toolbar}>
        <Boton variante="ghost" sm onClick={() => navigate(-1)} title="Volver">←</Boton>
        <div style={st.breadcrumb}>
          <span style={st.breadcrumbItem}>Remitos</span>
          <span style={st.breadcrumbSep}>›</span>
          <code style={st.breadcrumbNum}>{remito.numero_presea}</code>
        </div>
        <EstadoVigenteBadge estadoVigente={remito.estado_vigente} />
        <div style={st.toolbarSpacer} />
        <div style={st.toolbarAcciones}>
          {/* Imprimir remito (solo T90 — en T80 se imprime cada NE). Primera vez
              "Imprimir"; ya impreso → "Reimprimir" con motivo obligatorio. */}
          {!es80 && remito.estado !== 'anulado' && (
            (remito.impresiones_count || 0) === 0 ? (
              <Boton variante="secondary" disabled={imprimiendoRemito} onClick={handleImprimirRemito}>
                {imprimiendoRemito ? '…' : '🖨 Imprimir remito'}
              </Boton>
            ) : (
              <Boton variante="secondary" disabled={imprimiendoRemito}
                onClick={() => { setShowReimprimir(true); setErrorReimp('') }}
                title={`Ya impreso ${remito.impresiones_count}×. La reimpresión exige motivo.`}>
                🖨 Reimprimir ({remito.impresiones_count}×)
              </Boton>
            )
          )}
          {!es80 && remito.token_seguimiento && remito.estado !== 'anulado' && (
            <Boton variante="secondary" title="Copiar link de seguimiento para el cliente"
              onClick={async () => {
                await navigator.clipboard.writeText(`${window.location.origin}/seguimiento/${remito.token_seguimiento}`)
                setMsgAccion('Link de seguimiento copiado — pasáselo al cliente por WhatsApp o mail.')
              }}>
              🔗 Seguimiento
            </Boton>
          )}
          {/* Compartir comprobantes con el cliente — modal con checkboxes y dos
              canales: Mail (mailto) o WhatsApp (wa.me). Disponible apenas el
              remito está en logística (confirmado o más adelante). */}
          {remito.nota_venta && !['ingresado', 'anulado'].includes(remito.estado) && (
            <Boton variante="secondary" sm onClick={() => setShowCompartir(true)} title="Mandarle al cliente los comprobantes y el link de seguimiento">
              ✉ Compartir
            </Boton>
          )}
          {/* Encuesta de satisfacción de la venta (Sugerencia #111): solo con la NV facturada. */}
          {remito.nota_venta?.estado === 'procesado' && (
            <BotonEncuestaSatisfaccion nvId={remito.nota_venta.id} sm />
          )}
          {/* Entrega con problemas (rotura / faltante / mal estado) o siniestro
              del transporte: abre el caso y, con productos seleccionados,
              genera la reposición solo-remito que vuelve a Asignaciones. */}
          {(remito.estado === 'entregado' || remito.siniestro_at) && (
            <Boton variante={remito.siniestro_at ? 'primary' : 'secondary'} sm onClick={() => { setShowCaso(v => !v); setCasoError('') }}
              title={remito.siniestro_at
                ? 'Siniestro del transporte: registrar qué pasó y generar la reposición'
                : 'Rotura, faltante o mercadería en mal estado: registrar qué pasó y generar la reposición'}>
              ⚠️ Abrir caso
            </Boton>
          )}
          {/* Remito de NV: confirmación manual. Remito libre: confirma cuando
              Presea devuelve el número (botón Enviar a Presea). */}
          {remito.estado === 'ingresado' && !esLibre && (() => {
            // Regla 10 ago 2026: ningún T90 se confirma sin estar impreso —
            // el papel es el control de la preparación. El backend lo exige
            // (422); acá el botón lo anticipa.
            const faltaImprimir = remito.transporte === 90 && !(remito.impresiones_count > 0)
            return (
              <Boton
                variante="primary"
                disabled={confirmando || faltaImprimir}
                title={faltaImprimir ? 'Imprimí el remito antes de confirmarlo (🖨 Imprimir remito)' : undefined}
                onClick={handleConfirmar}
              >
                {confirmando ? 'Confirmando…' : (faltaImprimir ? 'Confirmar (imprimí primero)' : 'Confirmar')}
              </Boton>
            )
          })()}
          {remito.estado === 'ingresado' && esLibre && (
            <Boton variante="send" disabled={confirmando} onClick={handleEnviarPresea}>
              {confirmando ? 'Enviando…' : '→ Enviar a Presea'}
            </Boton>
          )}
          {es80 && !esParcial && remito.estado === 'confirmado' && (
            <Boton variante="secondary" onClick={() => navigate(`/remitos/${remito.id}/planilla`)}>
              Planilla
            </Boton>
          )}
          {/* Retira en depósito: la sucursal avisa cuando tiene todo listo… */}
          {remito.retira && remito.estado === 'confirmado' && !remito.disponible_retiro_at && (
            <Boton variante="secondary" disabled={confirmando} onClick={handleDisponibleRetiro} title="La sucursal ya tiene el remito y la mercadería — avisarle al cliente por mail">
              {confirmando ? 'Marcando…' : '📣 Avisar disponible'}
            </Boton>
          )}
          {/* …y la vía express cierra con un click, sin pasar por logística. */}
          {remito.retira && remito.estado === 'confirmado' && (
            <Boton variante="success" disabled={confirmando} onClick={handleMarcarRetirado}>
              {confirmando ? 'Marcando…' : '🏬 Marcar retirado'}
            </Boton>
          )}
          {/* Retiro ya marcado: se puede deshacer (la mercadería volvió al local) —
              es lo que en un envío a domicilio hace "revertir entrega" desde la salida. */}
          {remito.retira && remito.estado === 'entregado' && (
            <Boton variante="secondary" disabled={confirmando} onClick={handleDeshacerRetiro} title="Deshacer el retiro: el remito vuelve a confirmado">
              {confirmando ? 'Deshaciendo…' : '↩ Deshacer retiro'}
            </Boton>
          )}
          {/* Reparto → retiro en sucursal: si está en un viaje, se libera solo. */}
          {/* Fraude detectado en tránsito: sale de Asignación y espera que vuelva la mercadería. */}
          {!es80 && !remito.fraude_transito && ['fallo_sin_reasignar', 'disponible'].includes(remito.estado_vigente?.codigo) && remito.estado !== 'ingresado' && (
            <Boton variante="destructive" disabled={confirmando} onClick={() => { setMotivoFraude(''); setErrorAccion(''); setModalFraude(true) }}
              title="Es un fraude: sale de Asignaciones y queda esperando que la mercadería vuelva al depósito">
              🚫 Fraude — vuelve al depósito
            </Boton>
          )}
          {!es80 && !remito.retira && !remito.fraude_transito && ['ingresado', 'confirmado', 'asignado', 'en_distribucion', 'no_entregado', 'reagendado'].includes(remito.estado) && (
            <Boton variante="secondary" disabled={confirmando} onClick={abrirPasarARetiro} title="El cliente prefiere pasar a buscarlo: sale del reparto y entra a los retiros de la sucursal">
              🏬 Pasar a retiro
            </Boton>
          )}
          {/* Retiro pendiente → vuelve al circuito de reparto. */}
          {remito.retira && ['ingresado', 'confirmado'].includes(remito.estado) && (
            <Boton variante="secondary" disabled={confirmando} onClick={handleVolverAReparto} title="Deja de ser retiro: vuelve al reparto (asignar zona y salida)">
              🚚 Volver a reparto
            </Boton>
          )}
          {/* T90 confirmado → atajo directo a armar salida con este remito preseleccionado.
              Sin esto el operador tenía que ir a /asignaciones a buscarlo de nuevo.
              No aplica a "retira" (no pasa por salidas). */}
          {!es80 && !remito.retira && remito.estado === 'confirmado' && (() => {
            const env = remito.nota_venta?.direccion_envio || remito.direccion_envio
            const dir = (env && (env.calle || env.localidad)) ? env : remito.cliente
            const pre = [{
              entidad_tipo: 'remito',
              entidad_id: remito.id,
              label: remito.cliente?.nombre || remito.numero_presea,
              sub: remito.numero_presea,
              calle: dir?.calle || dir?.domicilio || '',
              localidad: dir?.localidad || '',
              cp: dir?.codigo_postal || '',
              zona: remito.zona?.nombre || '',
              zona_id: remito.zona?.id || remito.zona_id || null,
            }]
            return (
              <Boton variante="primary"
                onClick={() => navigate('/salidas/nueva', { state: { preseleccion: pre } })}
                title="Armar una salida con este remito preseleccionado">
                🚚 Asignar a salida
              </Boton>
            )
          })()}
          {/* Retira no cambia de transporte (no aplica T80). Un T90 confirmado
              pide autorización de un admin por Telegram (Martin, 4 sep 2026). */}
          {!remito.retira && !esParcial && ['ingresado', 'confirmado'].includes(remito.estado) && (
            remito.t80_autorizacion_pendiente ? (
              <span style={{ ...st.badge, background: '#fef9c3', color: '#a16207', padding: '8px 12px' }}
                title="Un administrador la resuelve desde el aviso de Telegram">
                ⏳ T80 pedido — espera autorización
              </span>
            ) : (
              <Boton variante="secondary" disabled={cambiandoTransporte} onClick={handleCambiarTransporte}
                title={!es80 && remito.estado === 'confirmado' ? 'Requiere autorización de un administrador (llega por Telegram con el botón para autorizar)' : undefined}>
                {cambiandoTransporte ? '…' : `Cambiar a T${es80 ? '90' : '80'}`}
              </Boton>
            )
          )}
          {!['anulado', 'entregado', 'en_distribucion'].includes(remito.estado) && !remito.anulacion_solicitada_at && (
            <Boton variante="destructive" onClick={() => setShowAnular(!showAnular)}>
              Anular
            </Boton>
          )}
          {remito.estado === 'anulado' && (
            <Boton variante="secondary" disabled={confirmando} onClick={handleRevertirAnulacion}
              title="Verifica en Presea que el remito exista y vuelve al estado anterior">
              {confirmando ? '…' : '↩ Revertir anulación'}
            </Boton>
          )}
        </div>
      </div>

      {msgAccion && <div style={st.successBox}>{msgAccion}</div>}
      {errorAccion && <div style={st.errorBox}>{errorAccion}</div>}

      {/* Anulación pedida: espera que Presea muestre el remito anulado */}
      {remito.anulacion_solicitada_at && remito.estado !== 'anulado' && (
        <div style={st.bannerPendiente}>
          <div>
            <strong>⏳ Anulación pedida</strong>
            <span style={{ marginLeft: 8, color: '#78350f' }}>
              Anulá el remito <strong>{remito.numero_presea}</strong> en Presea. LGR aprueba la anulación cuando Presea lo muestra anulado (lo revisa solo cada 15 min).
            </span>
            <div style={{ marginTop: 4, color: '#78350f' }}>
              Pedida por {remito.anulacion_solicitada_por_nombre || '—'} el {fmtFechaHora(remito.anulacion_solicitada_at)}
              {remito.anulacion_motivo && <> · Motivo: {remito.anulacion_motivo}</>}
              {remito.anulacion_verificada_at && <> · Último chequeo: {fmtFechaHora(remito.anulacion_verificada_at)}</>}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Boton variante="primary" disabled={confirmando} onClick={handleVerificarAnulacion}>
              {confirmando ? '…' : '🔎 Verificar en Presea'}
            </Boton>
            <Boton variante="ghost" disabled={confirmando} onClick={handleCancelarAnulacion}>Cancelar pedido</Boton>
          </div>
        </div>
      )}

      {/* Fraude detectado en tránsito: espera la mercadería y después la NC. */}
      {remito.fraude_transito && (
        <div style={st.bannerPendiente}>
          <div>
            <strong>{remito.fraude_transito.recibida_at ? '📦 Fraude — la mercadería volvió al depósito' : '🚫 Fraude — la mercadería vuelve al depósito'}</strong>
            <span style={{ marginLeft: 8, color: '#78350f' }}>
              {remito.fraude_transito.recibida_at
                ? (remito.fraude_transito.nc_hecha
                    ? 'La NC / Devolución de la venta ya está registrada: el stock volvió en Presea.'
                    : 'Falta la NC / Devolución de la venta en Presea para que vuelva al stock.')
                : 'Fuera de Asignaciones. Cuando llegue, confirmalo acá.'}
            </span>
            <div style={{ marginTop: 4, color: '#78350f' }}>
              Marcado por {remito.fraude_transito.marcado_por || '—'} el {fmtFechaHora(remito.fraude_transito.marcado_at)}
              {remito.fraude_transito.motivo && <> · {remito.fraude_transito.motivo}</>}
              {remito.fraude_transito.recibida_at && <> · Recibida por {remito.fraude_transito.recibida_por || '—'} el {fmtFechaHora(remito.fraude_transito.recibida_at)}</>}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {!remito.fraude_transito.recibida_at && (
              <Boton variante="success" disabled={confirmando} onClick={handleMercaderiaDevuelta}>📦 Llegó la mercadería</Boton>
            )}
            {remito.fraude_transito.caso_id && (
              <Boton variante="secondary" onClick={() => navigate(`/casos/${remito.fraude_transito.caso_id}`)}>Ver el caso →</Boton>
            )}
            {!remito.fraude_transito.caso_id && remito.fraude_transito.recibida_at && !remito.fraude_transito.nc_hecha && remito.fraude_transito.nota_venta_id && (
              <Boton variante="secondary" onClick={() => navigate(`/notas-venta/${remito.fraude_transito.nota_venta_id}`)}>Ir a la venta para la NC →</Boton>
            )}
          </div>
        </div>
      )}

      {/* Logística pide entregar antes de la fecha pactada: lo resuelve el
          vendedor que procesó la venta (o un administrador). */}
      {(remito.entregas_anticipadas || []).filter(a => a.estado === 'pendiente').map(a => (
        <div key={a.id} style={st.bannerPendiente}>
          <div>
            <strong>📅 Piden entregar antes de la fecha pactada</strong>
            <span style={{ marginLeft: 8, color: '#78350f' }}>
              {a.solicitante || 'Logística'} quiere entregar el <strong style={{ fontFamily: font.mono, fontVariantNumeric: 'tabular-nums' }}>{a.numero}</strong> — {a.motivo}. Autorizalo solo si el cliente puede recibirlo antes.
            </span>
            <div style={{ marginTop: 4, color: '#78350f' }}>
              Pedido el {fmtFechaHora(a.created_at)}
              {!a.puede_resolver && <> · Lo resuelve {a.responsables?.length ? a.responsables.join(' o ') : 'administración'}</>}
            </div>
          </div>
          {a.puede_resolver && (
            <div style={{ display: 'flex', gap: 8 }}>
              <Boton variante="success" disabled={confirmando} onClick={() => handleResolverAnticipada(a, 'aprobada')}>✓ Autorizar</Boton>
              <Boton variante="destructive" disabled={confirmando} onClick={() => handleResolverAnticipada(a, 'rechazada')}>✕ Rechazar</Boton>
            </div>
          )}
        </div>
      ))}

      {/* Banner T80 sin NE */}
      {es80 && !esParcial && remito.estado === 'confirmado' && (!remito.notas_envio || remito.notas_envio.length === 0) && (
        <div style={st.bannerPendiente}>
          <div>
            <strong>Falta generar las Notas de Envío.</strong>
            <span style={{ marginLeft: 8, color: '#78350f' }}>
              Un remito T80 requiere confirmación <em>y</em> generación de NEs (planilla) para pasar a logística.
            </span>
          </div>
          <Boton variante="primary" onClick={() => navigate(`/remitos/${remito.id}/planilla`)}>
            Ir a la planilla →
          </Boton>
        </div>
      )}
      {es80 && !esParcial && remito.estado === 'ingresado' && (
        <div style={st.bannerPendiente}>
          <strong>Próximo paso:</strong> confirmar el remito y luego generar las NEs desde la planilla para que pase a logística.
        </div>
      )}
      {esParcial && remito.estado === 'ingresado' && (
        <div style={st.bannerPendiente}>
          <strong>Próximo paso:</strong> confirmar el remito y después despachar cada parte desde «📦 Envío parcial».
        </div>
      )}

      {/* Form inline de anular */}
      {showAnular && (
        <div style={st.anularBox}>
          <strong style={{ fontSize: 13 }}>Motivo de la anulación:</strong>
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <input
              style={{ ...st.input, flex: 1 }}
              value={motivoAnular}
              onChange={e => setMotivoAnular(e.target.value)}
              placeholder="Ej: NC detectada por Presea"
            />
            <Boton variante="destructive" disabled={anulando} onClick={handleAnular}>
              {anulando ? 'Anulando…' : 'Confirmar'}
            </Boton>
            <Boton variante="ghost" onClick={() => { setShowAnular(false); setErrorAnular('') }}>Cancelar</Boton>
          </div>
          {errorAnular && <div style={st.error}>{errorAnular}</div>}
        </div>
      )}

      {/* Modal de reimpresión: motivo obligatorio, queda asentado en el historial */}
      {showReimprimir && (
        <div style={st.anularBox}>
          <strong style={{ fontSize: 13 }}>Motivo de la reimpresión (queda registrado):</strong>
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <input
              style={{ ...st.input, flex: 1 }}
              value={motivoReimp}
              onChange={e => setMotivoReimp(e.target.value)}
              placeholder="Ej: se manchó / el fletero perdió la copia"
              autoFocus
            />
            <Boton variante="secondary" disabled={imprimiendoRemito} onClick={handleReimprimirRemito}>
              {imprimiendoRemito ? '…' : '🖨 Reimprimir'}
            </Boton>
            <Boton variante="ghost" onClick={() => { setShowReimprimir(false); setErrorReimp('') }}>Cancelar</Boton>
          </div>
          {errorReimp && <div style={st.error}>{errorReimp}</div>}
        </div>
      )}

      {/* Caso de entrega: relato obligatorio + selección de productos a reponer.
          Con selección, se genera la NV de reposición SIN factura ni recibo
          (camino solo-remito) y el remito nuevo vuelve a Asignaciones. */}
      {showCaso && (
        <div style={st.anularBox}>
          <strong style={{ fontSize: 13 }}>Abrir caso — ¿qué pasó con la entrega?</strong>
          {remito.estado === 'entregado' && (
            <div role="radiogroup" style={{ display: 'flex', gap: space.md, marginTop: space.md }}>
              {[['reposicion', '🔁 Reponer'], ['devolucion', '↩ Devolver y reintegrar']].map(([v, label]) => (
                <button key={v} type="button" role="radio" aria-checked={casoTipo === v}
                  style={{ ...sx.pill, ...(casoTipo === v ? sx.pillActive : {}) }}
                  onClick={() => setCasoTipo(v)}>{label}</button>
              ))}
            </div>
          )}
          <textarea
            style={{ ...st.input, width: '100%', minHeight: 64, marginTop: 8, resize: 'vertical', boxSizing: 'border-box' }}
            value={casoDetalle}
            onChange={e => setCasoDetalle(e.target.value)}
            placeholder="Ej: llegaron 2 botellas rotas del Malbec y faltó el estuche"
            autoFocus
          />
          {casoTipo === 'devolucion' ? (
            <div style={{ margin: `${space.lg}px 0 ${space.sm}px`, fontSize: text.sec, color: colors.textSub }}>
              La devolución es <strong>total</strong>: vuelve todo lo de la factura (ARCA no admite una devolución
              parcial) y se le reintegra al cliente todo lo que pagó{(remito.articulos || []).some(ra => ra.articulo?.codigo_alfa === 'ENV0000') ? ', envío incluido' : ''},
              por el medio original de cada cobro. Se retira por el mismo medio de la entrega, y la plata sale cuando
              el depósito la recibe.
            </div>
          ) : (
            <div style={{ margin: `${space.lg}px 0 ${space.sm}px`, fontSize: text.sec, color: colors.textSub }}>
              Productos a reponer (opcional): al seleccionarlos se genera un remito nuevo al mismo
              cliente, sin factura ni recibo, que vuelve a <strong>Asignaciones</strong> para una nueva entrega.
            </div>
          )}
          {(remito.articulos || [])
            // En la devolución el envío no es un producto: va por su casilla.
            .filter(ra => casoTipo !== 'devolucion' || ra.articulo?.codigo_alfa !== 'ENV0000')
            .map(ra => {
            const art = ra.articulo?.factura_como || ra.articulo
            const sel = casoSel[ra.articulo_id] !== undefined
            // Devolución total: los renglones se muestran, no se eligen.
            if (casoTipo === 'devolucion') return (
              <div key={ra.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', fontSize: 13 }}>
                <span style={{ fontFamily: FONT_MONO, fontSize: 12, color: '#64748b' }}>{art?.codigo_alfa}</span>
                <span style={{ flex: 1 }}>{art?.descripcion}</span>
                <span style={{ fontFamily: FONT_MONO, fontSize: 12, color: '#94a3b8' }}>×{ra.cantidad}</span>
              </div>
            )
            return (
              <label key={ra.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', fontSize: 13, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={sel}
                  onChange={() => setCasoSel(prev => {
                    const next = { ...prev }
                    if (sel) delete next[ra.articulo_id]
                    else next[ra.articulo_id] = ra.cantidad
                    return next
                  })}
                />
                <span style={{ fontFamily: FONT_MONO, fontSize: 12, color: '#64748b' }}>{art?.codigo_alfa}</span>
                <span style={{ flex: 1 }}>{art?.descripcion}</span>
                {sel ? (
                  <input
                    type="number" min="1" max={ra.cantidad}
                    style={{ ...st.input, width: 64, textAlign: 'right' }}
                    value={casoSel[ra.articulo_id]}
                    onClick={e => e.preventDefault()}
                    onChange={e => setCasoSel(prev => ({ ...prev, [ra.articulo_id]: e.target.value }))}
                  />
                ) : (
                  <span style={{ fontFamily: FONT_MONO, fontSize: 12, color: '#94a3b8' }}>×{ra.cantidad}</span>
                )}
              </label>
            )
          })}
          {casoTipo === 'devolucion' && (
            <div style={{ display: 'flex', gap: space.xl, marginTop: space.md, flexWrap: 'wrap', fontSize: text.body, color: colors.text }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: space.sm, cursor: 'pointer' }}>
                <input type="checkbox" checked={casoRetiro} onChange={e => setCasoRetiro(e.target.checked)} />
                Se retira la mercadería {remito.retira ? '(el cliente la trae al local)' : remito.andreani_tracking ? '(por Andreani)' : '(transporte propio)'}
              </label>
            </div>
          )}
          <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
            <Boton variante="primary" disabled={casoEnviando} onClick={handleAbrirCaso}>
              {casoEnviando ? 'Abriendo…' : (casoTipo === 'devolucion' ? 'Abrir devolución' : 'Abrir caso')}
            </Boton>
            <Boton variante="ghost" onClick={() => { setShowCaso(false); setCasoError('') }}>Cancelar</Boton>
          </div>
          {casoError && <div style={st.error}>{casoError}</div>}
        </div>
      )}

      {/* Modal: compartir comprobantes con el cliente (mail / WhatsApp). El
          cliente se pasa explícito (el detalle del remito ya lo trae cargado;
          notaVenta del show NO incluye cliente para no engordar la query). */}
      {modalRetiro && (
        <Modal title="Pasar a retiro en sucursal" onClose={() => setModalRetiro(false)} maxWidth="520px">
          <p style={{ margin: '0 0 12px', fontSize: 13, color: '#64748b' }}>
            El cliente pasa a buscar el pedido. {['asignado', 'en_distribucion', 'no_entregado', 'reagendado'].includes(remito.estado) ? 'El remito se saca del viaje en el que está y ' : 'El remito '}
            entra a la lista de retiros de la sucursal (Distribución → Retiros). Después reimprimilo: el papel pasa a decir "RETIRA EN SUCURSAL".
          </p>
          <label style={{ display: 'block', fontWeight: 600, marginBottom: 3, fontSize: 12 }}>¿Dónde lo retira?</label>
          <select value={sucursalElegida} onChange={e => setSucursalElegida(e.target.value)} style={{ width: '100%', padding: '6px 10px', marginBottom: 12, fontSize: 13 }}>
            {sucursales.length === 0 && <option value="">Cargando…</option>}
            {sucursales.map(s => <option key={s.id} value={s.id}>{s.nombre} — {s.direccion}</option>)}
          </select>
          <label style={{ display: 'block', fontWeight: 600, marginBottom: 3, fontSize: 12 }}>Motivo (opcional)</label>
          <input value={motivoRetiro} onChange={e => setMotivoRetiro(e.target.value)} maxLength={250} style={{ width: '100%', padding: '6px 10px', marginBottom: 12, fontSize: 13, boxSizing: 'border-box' }} placeholder="Ej: el cliente lo pidió por teléfono" />
          {errorAccion && <p style={{ color: '#991b1b', fontSize: 13 }}>{errorAccion}</p>}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Boton variante="ghost" onClick={() => setModalRetiro(false)}>Cancelar</Boton>
            <Boton variante="primary" disabled={!sucursalElegida || confirmando} onClick={handlePasarARetiro}>{confirmando ? 'Pasando…' : 'Pasar a retiro'}</Boton>
          </div>
        </Modal>
      )}
      {modalFraude && (
        <Modal title="Fraude — vuelve al depósito" onClose={() => setModalFraude(false)} maxWidth="520px">
          <p style={{ margin: '0 0 12px', fontSize: 13, color: '#64748b' }}>
            El remito sale de Asignaciones y queda <strong>esperando que la mercadería vuelva al depósito</strong>. El cliente pasa a la lista negra y la venta se marca como fraude. El cobro no se toca.
            Cuando la mercadería llegue, confirmalo acá; el stock vuelve con la NC / Devolución de la venta.
          </p>
          <label style={{ display: 'block', fontWeight: 600, marginBottom: 3, fontSize: 12 }}>¿Qué pasó?</label>
          <input value={motivoFraude} onChange={e => setMotivoFraude(e.target.value)} maxLength={1000} style={{ width: '100%', padding: '6px 10px', marginBottom: 12, fontSize: 13, boxSizing: 'border-box' }} placeholder="Ej: fraude detectado en tránsito, Andreani lo devuelve" />
          {errorAccion && <p style={{ color: '#991b1b', fontSize: 13 }}>{errorAccion}</p>}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Boton variante="ghost" onClick={() => setModalFraude(false)}>Cancelar</Boton>
            <Boton variante="destructive" disabled={!motivoFraude.trim() || confirmando} onClick={handleFraudeTransito}>{confirmando ? 'Marcando…' : '🚫 Marcar fraude'}</Boton>
          </div>
        </Modal>
      )}
      <ModalCompartirCliente
        abierto={showCompartir}
        onClose={() => setShowCompartir(false)}
        remito={remito}
        nv={remito.nota_venta}
        cliente={remito.cliente}
      />

      {/* Grid 2-col: documento+operativa | meta+comercial+historial */}
      <div style={st.grid}>
        {/* MAIN: Documento + NEs + Entregas */}
        <div style={st.mainCol}>

          <div style={st.documento}>
            <div style={st.docHeader}>
              <div style={st.docHeaderLeft}>
                <div style={st.docLabel}>Remito</div>
                <div style={st.docNumero}>{remito.numero_presea}</div>
              </div>
              <div style={st.docHeaderRight}>
                {remito.transporte != null && (
                  <span style={{ ...st.badge, ...(es80 ? st.badgeT80 : st.badgeT90) }}>T{remito.transporte}</span>
                )}
                {remito.zona?.nombre && <span style={st.badgeZona}>{remito.zona.nombre}</span>}
              </div>
            </div>

            <div style={st.docCliente}>
              <div style={st.docClienteNombre}>{remito.cliente?.nombre}</div>
              <div style={st.docClienteDatos}>
                {remito.cliente?.codigo_presea && <span style={st.docMono}>#{remito.cliente.codigo_presea}</span>}
                {remito.cliente?.cuit && <><span style={st.docMetaSep}>·</span><span style={st.docMono}>CUIT {remito.cliente.cuit}</span></>}
              </div>
              {(() => {
                // Retiro: el cliente pasa a buscar — se muestra DÓNDE retira,
                // nunca su dirección (sugerencias #34/#37).
                if (remito.retira) {
                  const suc = remito.sucursal_retiro_info
                  return (
                    <div style={st.docEntrega}>
                      <div style={st.docEntregaLabel}>Retira en</div>
                      <div style={st.docEntregaDatos}>
                        <span>🏬 {suc?.nombre || 'Depósito'}</span>
                        {suc?.direccion && <><span style={st.docMetaSep}>·</span><span>{suc.direccion}</span></>}
                        {remito.cliente?.telefono && <><span style={st.docMetaSep}>·</span><span style={st.docMono}>{remito.cliente.telefono}</span></>}
                        {remito.disponible_retiro_at && (
                          <><span style={st.docMetaSep}>·</span><span title="La sucursal marcó la mercadería como disponible y se le avisó al cliente">📣 Disponible desde {fmtFechaHora(remito.disponible_retiro_at)}</span></>
                        )}
                      </div>
                    </div>
                  )
                }
                const env = remito.nota_venta?.direccion_envio || remito.direccion_envio
                const tieneEnv = env && (env.calle || env.localidad || env.codigo_postal)
                const dest = tieneEnv ? {
                  calle: env.calle, localidad: env.localidad, provincia: env.provincia,
                  cp: env.codigo_postal, telefono: env.telefono, receptor: env.receptor_nombre,
                } : {
                  calle: remito.cliente?.domicilio, localidad: remito.cliente?.localidad,
                  provincia: remito.cliente?.provincia, cp: remito.cliente?.codigo_postal,
                  telefono: remito.cliente?.telefono,
                }
                return (
                  <div style={st.docEntrega}>
                    <div style={st.docEntregaLabel}>Entregar en{tieneEnv ? '' : ' (domicilio del cliente)'}</div>
                    <div style={st.docEntregaDatos}>
                      {dest.calle && <span>{dest.calle}</span>}
                      {dest.localidad && <><span style={st.docMetaSep}>·</span><span>{dest.localidad}{dest.provincia ? `, ${dest.provincia}` : ''}</span></>}
                      {dest.cp && <><span style={st.docMetaSep}>·</span><span style={st.docMono}>CP {dest.cp}</span></>}
                      {dest.receptor && <><span style={st.docMetaSep}>·</span><span>Recibe: {dest.receptor}</span></>}
                      {dest.telefono && <><span style={st.docMetaSep}>·</span><span style={st.docMono}>{dest.telefono}</span></>}
                    </div>
                  </div>
                )
              })()}
            </div>

            {remito.articulos?.length > 0 && (
              <div style={st.docDetalle}>
                <table style={st.docTable}>
                  <thead>
                    <tr>
                      <th style={st.docThNum}>#</th>
                      <th style={st.docTh}>Código</th>
                      <th style={st.docTh}>Descripción</th>
                      <th style={{ ...st.docTh, textAlign: 'right' }}>Cantidad</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(remito.articulos.every(ra => ra.oculto_impresos) ? remito.articulos : remito.articulos.filter(ra => !ra.oculto_impresos)).map((ra, idx) => (
                      <tr key={ra.id} style={st.docTr}>
                        <td style={st.docTdNum}>{idx + 1}</td>
                        {/* Alias Magento → mostrar el artículo facturable vinculado */}
                        <td style={st.docTdCodigo}>{(ra.articulo?.factura_como || ra.articulo)?.codigo_alfa}</td>
                        <td style={st.docTd}>{(ra.articulo?.factura_como || ra.articulo)?.descripcion}</td>
                        <td style={{ ...st.docTd, textAlign: 'right', fontFamily: FONT_MONO, fontWeight: 600 }}>{ra.cantidad}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* Envío, gift cards y eventos van en la factura pero no se
                    entregan: fuera de la lista de logística (sug #97). */}
                {remito.articulos.some(ra => ra.oculto_impresos) && !remito.articulos.every(ra => ra.oculto_impresos) && (
                  <div style={{ fontSize: 12, color: '#64748b', padding: '6px 10px' }}>
                    Sin entrega física (solo factura): {remito.articulos.filter(ra => ra.oculto_impresos)
                      .map(ra => `${(ra.articulo?.factura_como || ra.articulo)?.descripcion || (ra.articulo?.factura_como || ra.articulo)?.codigo_alfa} ×${ra.cantidad}`).join(' · ')}
                  </div>
                )}
              </div>
            )}
          </div>

          {esParcial && <EnvioParcialCard remito={remito} onCambio={cargar} />}

          {/* NEs (T80) */}
          {es80 && (() => {
            const totalNe = remito.notas_envio?.length || 0
            const pendientesImprimir = (remito.notas_envio || []).filter(ne => ne.estado !== 'anulado' && !(ne.impresiones_count > 0)).length
            return (
            <div style={st.card}>
              <div style={st.cardHeader}>
                <h3 style={st.cardTitle}>{esParcial ? `Partes del envío (${totalNe})` : `Notas de envío (${totalNe})`}</h3>
                <div style={{ display: 'flex', gap: 6 }}>
                  {pendientesImprimir > 0 && (
                    <Boton variante="primary" sm disabled={imprimiendoMasivo} onClick={handleImprimirMasivo}>
                      {imprimiendoMasivo ? '…' : `🖨 Imprimir todas (${pendientesImprimir})`}
                    </Boton>
                  )}
                  {!esParcial && (
                  <Boton variante="secondary" sm onClick={() => navigate(`/remitos/${remito.id}/planilla`)}>
                    + Desde planilla
                  </Boton>
                  )}
                </div>
              </div>
              {msgNe && (
                <div style={{ padding: '6px 10px', borderRadius: 6, marginBottom: 10,
                  background: msgNe.startsWith('Error') || msgNe.includes('ya fue') ? '#fee2e2' : '#dcfce7',
                  color: msgNe.startsWith('Error') || msgNe.includes('ya fue') ? '#991b1b' : '#166534',
                  fontSize: 13 }}>
                  {msgNe}
                </div>
              )}
              {(!remito.notas_envio || remito.notas_envio.length === 0) ? (
                <p style={st.hint}>{esParcial ? 'Todavía no salió ninguna parte.' : 'Sin notas de envío generadas. Use la planilla de envío para generarlas.'}</p>
              ) : (
                <table style={st.neTable}>
                  <thead>
                    <tr>
                      {['Nº NE', 'Destinatario', 'Zona', 'Fecha est.', 'Estado', 'Imp.', ''].map(h => (
                        <th key={h} style={st.neTh}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {remito.notas_envio.map(ne => {
                      const yaImpresa = (ne.impresiones_count || 0) > 0
                      const estaImprimiendo = imprimiendoNe === ne.id
                      const estaReimprimiendo = reimprisiendoNe === ne.id
                      return (
                        <tr key={ne.id} style={st.neTr}>
                          <td style={st.neTdMono}>{ne.numero_ne}</td>
                          <td style={st.neTd}>
                            <div style={st.neDest}>{ne.destinatario?.nombre}</div>
                            {ne.destinatario?.localidad && (
                              <div style={st.neDestSec}>{ne.destinatario.localidad}</div>
                            )}
                          </td>
                          <td style={st.neTdSec}>{ne.zona?.nombre || <span style={st.placeholder}>—</span>}</td>
                          <td style={st.neTdSec}>{ne.fecha_entrega_est ? fmtFecha(ne.fecha_entrega_est) : '—'}</td>
                          <td style={st.neTd}><EstadoVigenteBadge estadoVigente={ne.estado_vigente} /></td>
                          <td style={st.neTd}>
                            <span style={{ fontSize: 12, color: yaImpresa ? '#166534' : '#94a3b8', fontFamily: FONT_MONO }}>
                              {ne.impresiones_count || 0}×
                            </span>
                          </td>
                          <td style={st.neTdAcc}>
                            <div style={{ display: 'flex', gap: 4, justifyContent: 'flex-end' }}>
                              <Boton variante="secondary" sm onClick={() => navigate(`/notas-envio/${ne.id}`)}>Ver</Boton>
                              {/* Parte cargada por error: se deshace mientras no se
                                  imprimió ni salió a reparto (el backend lo valida). */}
                              {esParcial && !yaImpresa && ne.estado !== 'anulado' && !ne.disponible_retiro_at && ['disponible', 'retira'].includes(ne.estado_vigente?.codigo) && (
                                <Boton variante="ghost" sm onClick={() => handleDeshacerParte(ne)}>Deshacer</Boton>
                              )}
                              {ne.estado === 'anulado' ? (
                                <span style={{ fontSize: 12, color: colors.textMeta }}>Deshecha</span>
                              ) : !yaImpresa ? (
                                <Boton variante="primary" sm disabled={estaImprimiendo} onClick={() => handleImprimir(ne.id)}>
                                  {estaImprimiendo ? '…' : 'Imprimir'}
                                </Boton>
                              ) : (
                                <Boton variante="secondary" sm disabled={estaReimprimiendo} onClick={() => handleReiprimir(ne.id)}>
                                  {estaReimprimiendo ? '…' : 'Reimp.'}
                                </Boton>
                              )}
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              )}
            </div>
            )
          })()}

          {/* Entregas */}
          {entregas.length > 0 && (
            <div style={st.card}>
              <h3 style={st.cardTitle}>Entregas ({entregas.length})</h3>
              {entregas.map((e, i) => {
                const cfg = ENTREGA_CFG[e.estado_entrega] || ENTREGA_CFG.pendiente
                return (
                  <div key={i} style={st.entregaBox}>
                    <div style={st.entregaHeader}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <code style={st.entregaTag}>{e.numero}</code>
                        {e.destinatario && <span style={st.entregaDest}>{e.destinatario}</span>}
                      </div>
                      <span style={{ ...st.entregaBadge, background: cfg.bg, color: cfg.color }}>{cfg.label}</span>
                    </div>
                    {e.salida?.fletero && (
                      <div style={st.entregaRow}>
                        <span style={st.entregaLbl}>Fletero</span>
                        <span style={st.entregaVal}>
                          <strong>{e.salida.fletero.nombre}</strong>
                          {e.salida.fletero.vehiculo && <span style={st.entregaChip}>🚚 {e.salida.fletero.vehiculo}</span>}
                          {e.salida.fletero.telefono && <span style={st.entregaChip}>📞 {e.salida.fletero.telefono}</span>}
                        </span>
                      </div>
                    )}
                    {e.salida && (
                      <div style={st.entregaRow}>
                        <span style={st.entregaLbl}>Salida</span>
                        <span style={st.entregaVal}>
                          #{e.salida.id} · {fmtFecha(e.salida.fecha)}
                          <button style={st.entregaLink} onClick={() => navigate(`/salidas/${e.salida.id}`)}>Ver salida →</button>
                        </span>
                      </div>
                    )}
                    {e.receptor_nombre && (
                      <div style={st.entregaRow}>
                        <span style={st.entregaLbl}>Recibió</span>
                        <span style={st.entregaVal}><strong>{e.receptor_nombre}</strong></span>
                      </div>
                    )}
                    {e.entregado_at && (
                      <div style={st.entregaRow}>
                        <span style={st.entregaLbl}>Fecha/hora</span>
                        <span style={{ ...st.entregaVal, fontFamily: FONT_MONO, fontSize: 12 }}>{fmtFechaHora(e.entregado_at)}</span>
                      </div>
                    )}
                    {e.motivo_no_entrega && (
                      <div style={st.entregaRow}>
                        <span style={st.entregaLbl}>Motivo</span>
                        <span style={{ ...st.entregaVal, color: '#991b1b' }}>{e.motivo_no_entrega}</span>
                      </div>
                    )}
                    {e.nueva_fecha && (
                      <div style={st.entregaRow}>
                        <span style={st.entregaLbl}>Reagendado</span>
                        <span style={st.entregaVal}>{fmtFecha(e.nueva_fecha)}</span>
                      </div>
                    )}
                    {e.notas && (
                      <div style={st.entregaRow}>
                        <span style={st.entregaLbl}>Notas</span>
                        <span style={{ ...st.entregaVal, fontStyle: 'italic', color: '#64748b' }}>{e.notas}</span>
                      </div>
                    )}
                    {e.instrucciones_cli && (
                      <div style={st.entregaRow}>
                        <span style={st.entregaLbl}>🛎️ Cliente</span>
                        <span style={{ ...st.entregaVal, color: '#0f766e', fontWeight: 600 }}>{e.instrucciones_cli}</span>
                      </div>
                    )}
                    {e.imagenes?.length > 0 && (
                      <div style={{ marginTop: 10 }}>
                        <p style={{ ...st.entregaLbl, marginBottom: 6 }}>Fotos ({e.imagenes.length})</p>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                          {e.imagenes.map((img, j) => (
                            <img key={j} src={img.data} alt={`Foto ${j+1}`} style={st.entregaThumb}
                              onClick={() => setImgModal(img.data)} />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          )}

        </div>

        {/* ASIDE: Meta + Comercial + Historial */}
        <div style={st.asideCol}>

          {/* Meta */}
          <div style={st.card}>
            <h3 style={st.cardTitle}>Meta</h3>
            <Row label="Fecha" mono>{fmtFecha(remito.fecha_emision)}</Row>
            {/* Fecha de entrega estimada: visible siempre (sug #50) y editable
                en cualquier etapa salvo entregado/anulado (sug #51). */}
            <Row label="Entrega est.">
              {editandoFecha ? (
                <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start' }}>
                  <input
                    type="date"
                    value={fechaEdit}
                    onChange={e => setFechaEdit(e.target.value)}
                    style={{ padding: '3px 6px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 12, fontFamily: FONT_MONO }}
                  />
                  <input
                    type="text"
                    value={horarioEdit}
                    onChange={e => setHorarioEdit(e.target.value)}
                    placeholder="Horario (ej: 12 a 18)"
                    maxLength={120}
                    title="Se imprime en el remito tal como lo escribas"
                    style={{ padding: '3px 6px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 12, width: 180 }}
                  />
                  <span style={{ display: 'inline-flex', gap: 6 }}>
                    <Boton variante="primary" sm disabled={guardandoFecha} onClick={handleGuardarFecha}>
                      {guardandoFecha ? '…' : 'Guardar'}
                    </Boton>
                    <Boton variante="ghost" sm onClick={() => setEditandoFecha(false)}>✕</Boton>
                  </span>
                </span>
              ) : (
                <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
                  <span style={{ fontFamily: FONT_MONO }}>
                    {remito.fecha_entrega_est
                      ? remito.ventana_entrega
                      : <span style={st.placeholder}>A coordinar</span>}
                  </span>
                  {!['entregado', 'anulado'].includes(remito.estado) && (
                    <button
                      style={st.rowLink}
                      title="Cambiar la fecha de entrega estimada"
                      onClick={() => {
                        setFechaEdit(remito.fecha_entrega_est ? String(remito.fecha_entrega_est).slice(0, 10) : '')
                        setHorarioEdit(remito.horario_entrega || '')
                        setEditandoFecha(true)
                      }}
                    >
                      ✏️
                    </button>
                  )}
                </span>
              )}
            </Row>
            <Row label="Transporte">
              {remito.transporte == null
                ? <span style={st.placeholder}>—</span>
                : `T${remito.transporte} ${es80 ? 'virtual' : 'físico'}`}
            </Row>
            <Row label="Zona">{remito.zona?.nombre || <span style={st.placeholder}>Sin zona</span>}</Row>
            {/* Valor declarado (sug #38): solo cuando se cargó. */}
            {parseFloat(remito.valor_declarado) > 0 && (
              <Row label="Valor decl." mono>$ {fmtMonto(remito.valor_declarado)}</Row>
            )}
            {/* Indicaciones de packaging (sale impreso como ENTREGAR CON:). */}
            {remito.indicaciones_packaging && (
              <Row label="Packaging">{remito.indicaciones_packaging}</Row>
            )}
            {/* Instrucciones que dejó el cliente desde su portal (viajan a la parada al armar la salida). */}
            {remito.instrucciones_cli && (
              <Row label="🛎️ Cliente"><span style={{ color: '#0f766e', fontWeight: 600 }}>{remito.instrucciones_cli}</span></Row>
            )}
            {nv && (
              <Row label="NV" last>
                <button style={st.rowLink} onClick={() => navigate(`/notas-venta/${nv.id}`)}>
                  {nv.numero_lgr} →
                </button>
              </Row>
            )}
            {!nv && <Row label="NV" last><span style={st.placeholder}>—</span></Row>}
          </div>

          {/* Envío Andreani: tracking + guía. Solo T90 físico sin retiro.
              La zona Interior lo sugiere fuerte; el botón está igual para
              cualquier T90 (herramienta del operador, la alerta ya avisa). */}
          {remito.transporte === 90 && !remito.retira && remito.estado !== 'anulado' && (
            <div style={st.card}>
              <h3 style={st.cardTitle}>Envío Andreani</h3>
              {remito.andreani_tracking && (
                <>
                  <Row label="Tracking" mono>
                    <span style={{ userSelect: 'all' }}>{remito.andreani_tracking}</span>
                  </Row>
                  {(remito.andreani_trackings?.length || 0) > 1 && (
                    <Row label={`Bultos (${remito.andreani_trackings.length})`} mono>
                      <div>
                        {remito.andreani_trackings.map((t, i) => (
                          <div key={t} style={{ whiteSpace: 'nowrap' }}>
                            {i + 1}/{remito.andreani_trackings.length} · <span style={{ userSelect: 'all' }}>{t}</span>
                          </div>
                        ))}
                      </div>
                    </Row>
                  )}
                  <Row label="Generado" mono>{fmtFechaHora(remito.andreani_creado_at)}</Row>
                  {remito.andreani_estado && (
                    <Row label="Estado">
                      <span title={remito.andreani_estado_at ? `Visto ${fmtFechaHora(remito.andreani_estado_at)}` : undefined}>
                        {remito.andreani_estado}
                      </span>
                    </Row>
                  )}
                  {remito.andreani_devuelto_at && (
                    <Row label="Devuelto">
                      <span style={{ color: '#991b1b', fontWeight: 600 }}>
                        {remito.andreani_devuelto_detalle || 'Devuelto por Andreani'} · {fmtFechaHora(remito.andreani_devuelto_at)}
                      </span>
                    </Row>
                  )}
                  {remito.siniestro_at && (
                    <Row label="Siniestro">
                      <span style={{ color: '#991b1b', fontWeight: 600 }}>
                        {remito.siniestro_detalle || 'Siniestrado'} · {fmtFechaHora(remito.siniestro_at)}
                      </span>
                    </Row>
                  )}
                  <Row label="Seguimiento">
                    <a
                      href={`https://www.andreani.com/envio/${encodeURIComponent(remito.andreani_tracking)}`}
                      target="_blank" rel="noreferrer" style={st.rowLink}
                    >andreani.com ↗</a>
                  </Row>
                  <div style={{ marginTop: 10 }}>
                    <Boton
                      variante="secondary" sm
                      onClick={async () => {
                        setAndreani(a => ({ ...a, error: '' }))
                        try { await abrirArchivoEnPestana(`/remitos/${remito.id}/andreani/etiqueta`) }
                        catch (e) { setAndreani(a => ({ ...a, error: e.message })) }
                      }}
                    >🏷 Etiquetas{(remito.andreani_trackings?.length || 0) > 1 ? ` (${remito.andreani_trackings.length} bultos)` : ' (PDF)'}</Boton>
                  </div>
                  <AndreaniHistorial url={`/remitos/${remito.id}/andreani/eventos`} />
                </>
              )}
              {/* Sin guía, o con una que Andreani DEVOLVIÓ (sug #132, 28 oct
                  2026): el envío vuelve a salir con una guía nueva — el
                  servidor ya lo permite (AndreaniDespachoService). */}
              {(!remito.andreani_tracking || remito.andreani_devuelto_at) && (
                <>
                  {remito.andreani_devuelto_at && (
                    <p style={{ ...st.hint, marginTop: 14, fontWeight: 600, color: 'inherit' }}>
                      Reenviar: el paquete volvió. Generá una guía nueva para despacharlo otra vez.
                    </p>
                  )}
                  <p style={st.hint}>
                    Genera la orden en Andreani: reparte la carga en cajas de 6 botellas de 750
                    (la de 1,5 L ocupa 2; desde 3 L cada botella va sola) y devuelve una etiqueta
                    por bulto, con su número de seguimiento.
                  </p>
                  {remito.valor_declarado_venta > 0 ? (
                    <p style={{ ...st.hint, marginBottom: 8 }}>
                      Valor declarado: <b>$ {fmtMonto(remito.valor_declarado_venta)}</b> (valor de la venta ÷ 1,21 ÷ 2)
                    </p>
                  ) : (
                  <label style={{ ...st.hint, display: 'block', marginBottom: 8 }}>
                    Valor declarado (lo que asegura Andreani si hay un siniestro)
                    <input
                      data-nocaps
                      inputMode="decimal"
                      placeholder="Ej. el valor de la mercadería"
                      value={valorAndreani ?? (parseFloat(remito.valor_declarado) > 0 ? String(parseFloat(remito.valor_declarado)).replace('.', ',') : remito.valor_declarado_venta > 0 ? String(remito.valor_declarado_venta).replace('.', ',') : '')}
                      onChange={e => setValorAndreani(e.target.value)}
                      style={{ ...st.input, display: 'block', width: '100%', marginTop: 4, boxSizing: 'border-box' }}
                    />
                  </label>
                  )}
                  <Boton
                    variante="secondary" sm
                    disabled={andreani.generando}
                    onClick={async () => {
                      const texto = valorAndreani ?? (parseFloat(remito.valor_declarado) > 0 ? String(parseFloat(remito.valor_declarado)).replace('.', ',') : remito.valor_declarado_venta > 0 ? String(remito.valor_declarado_venta).replace('.', ',') : '')
                      const valor = parseFloat(String(texto).replace(/\./g, '').replace(',', '.'))
                      // Remito de una venta: el valor lo calcula LGR (no viaja desde acá).
                      if (remito.valor_declarado_venta > 0) {
                        setAndreani({ generando: true, error: '' })
                        try {
                          await postAndreaniConAviso(`/remitos/${remito.id}/andreani`, {})
                          await cargar()
                          setAndreani({ generando: false, error: '' })
                        } catch (err) {
                          const d = err.response?.data
                          setAndreani({ generando: false, error: d?.message || Object.values(d?.errors || {}).flat().join(' ') || 'No se pudo generar la orden.' })
                        }
                        return
                      }
                      if (!(valor > 0)) {
                        setAndreani({ generando: false, error: 'Cargá el valor declarado: sin él Andreani no cubre un siniestro.' })
                        return
                      }
                      setAndreani({ generando: true, error: '' })
                      try {
                        await postAndreaniConAviso(`/remitos/${remito.id}/andreani`, { valor_declarado: valor })
                        await cargar()
                        setAndreani({ generando: false, error: '' })
                      } catch (err) {
                        const d = err.response?.data
                        setAndreani({
                          generando: false,
                          error: d?.message || Object.values(d?.errors || {}).flat().join(' ') || 'No se pudo generar la orden.',
                        })
                      }
                    }}
                  >{andreani.generando ? 'Generando…' : '📦 Generar envío Andreani'}</Boton>
                </>
              )}
              {andreani.error && <p style={{ ...st.hint, color: '#b91c1c', marginTop: 8 }}>{andreani.error}</p>}
            </div>
          )}

          {/* Comercial */}
          {nv && (
            <div style={st.card}>
              <h3 style={st.cardTitle}>Comercial</h3>
              {(() => {
                if (facturas.length === 0) return <p style={st.hint}>Sin factura asociada.</p>
                const items = nv.items || []
                const subtotal = items.reduce((acc, it) => acc + (parseFloat(it.precio_final) || 0) * (parseInt(it.cantidad) || 0), 0)
                const descGral = parseFloat(nv.descuento_gral) || 0
                const totalFactura = subtotal * (1 - descGral / 100)
                return facturas.map(f => (
                  <div key={f.id} style={st.comercialBlock}>
                    <div style={st.comercialBlockTitle}>Factura</div>
                    <Row label="Tipo">{`Factura ${nv.tipo_factura || '—'}`}</Row>
                    <Row label="Nº" mono>{f.numero_presea || '—'}</Row>
                    <Row label="Importe" mono><strong style={{ color: '#0f172a' }}>${fmtMonto(totalFactura)}</strong></Row>
                    {f.url_presea ? (
                      <Row label="PDF" last>
                        <a href={f.url_presea} target="_blank" rel="noreferrer" style={st.rowLink}>Ver →</a>
                      </Row>
                    ) : <Row label="PDF" last><span style={st.placeholder}>—</span></Row>}
                  </div>
                ))
              })()}
              {pagos.length > 0 && (() => {
                // Total cobrado = lo que dice el backend (confirmado + acreditado,
                // devoluciones restan). Los rechazados/anulados/devueltos no suman (sug #108).
                const NO_SUMAN = ['rechazado', 'anulado', 'devuelto']
                const total = nv.cobrado ?? 0
                return (
                  <div style={st.comercialBlock}>
                    <div style={st.comercialBlockTitle}>Pagos ({pagos.length})</div>
                    {pagos.map(p => (
                      <div key={p.id} style={st.pagoBox}>
                        <Row label="Importe" mono><strong style={{ color: '#0f172a' }}>${fmtMonto(p.importe)}</strong></Row>
                        <Row label="Medio">{p.medio_pago?.descripcion || '—'}</Row>
                        <Row label="Fecha" mono>{p.fecha ? fmtFecha(p.fecha) : '—'}</Row>
                        <Row label="Estado" last>
                          <span style={{ ...st.estadoChip, ...(p.estado === 'acreditado' ? st.estadoOk : NO_SUMAN.includes(p.estado) ? st.estadoMal : st.estadoPend) }}>
                            {p.estado || 'pendiente'}
                          </span>
                          {NO_SUMAN.includes(p.estado) && <span style={st.noSuma}> no suma al total</span>}
                        </Row>
                      </div>
                    ))}
                    {pagos.length > 1 && (
                      <div style={st.comercialTotal}>
                        <span style={st.rowLabel}>Total cobrado</span>
                        <strong style={{ fontFamily: FONT_MONO, fontSize: 14, color: '#0f172a' }}>${fmtMonto(total)}</strong>
                      </div>
                    )}
                  </div>
                )
              })()}
              {pagos.length === 0 && facturas.length > 0 && <p style={st.hint}>Sin pagos registrados.</p>}
            </div>
          )}

          {/* Impresiones (solo T90) */}
          {!es80 && remito.impresiones?.length > 0 && (
            <div style={st.card}>
              <h3 style={st.cardTitle}>Impresiones ({remito.impresiones.length})</h3>
              <div style={st.historialList}>
                {remito.impresiones.map((imp, i) => (
                  <div key={i} style={st.historialItem}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: imp.es_reimpresion ? '#92400e' : '#166534' }}>
                      {imp.es_reimpresion ? 'Reimpresión' : 'Primera impresión'}
                    </div>
                    <div style={st.historialMeta}>{fmtFechaHora(imp.created_at)}</div>
                    {imp.usuario && <div style={st.historialUser}>{imp.usuario.nombre}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Casos de entrega: roturas / faltantes / mal estado + su reposición. */}
          {remito.casos?.length > 0 && (
            <div style={st.card}>
              <h3 style={st.cardTitle}>⚠️ Casos de entrega ({remito.casos.length})</h3>
              {remito.casos.map(caso => (
                <div key={caso.id} style={{ padding: '10px 0', borderBottom: '1px solid #f1f5f9', fontSize: 13 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <strong>Caso #{caso.id}</strong>
                    <span style={{
                      fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em',
                      padding: '2px 8px', borderRadius: 999,
                      background: caso.estado === 'abierto' ? '#fef3c7' : '#dcfce7',
                      color: caso.estado === 'abierto' ? '#92400e' : '#166534',
                    }}>{caso.estado}</span>
                    {caso.nota_envio && (
                      <span style={{ color: '#6d28d9', fontSize: 12, fontWeight: 600 }}>
                        NE {caso.nota_envio.numero_ne}
                      </span>
                    )}
                    <span style={{ color: '#64748b', fontSize: 12 }}>
                      {caso.usuario?.nombre} · {fmtFechaHora(caso.created_at)}
                    </span>
                  </div>
                  <div style={{ marginTop: 4, color: '#334155' }}>{caso.detalle}</div>
                  {caso.items?.length > 0 && (
                    <div style={{ marginTop: 4, color: '#64748b', fontSize: 12 }}>
                      {caso.tipo === 'devolucion' ? 'Devuelve' : 'Repone'}: {caso.items.map(i => `${i.cantidad}× ${i.codigo || i.descripcion}`).join(' · ')}
                    </div>
                  )}
                  {caso.tipo === 'devolucion' && (
                    <div style={{ marginTop: space.sm, display: 'flex', gap: space.lg, alignItems: 'center', fontSize: text.sec, color: colors.textSub }}>
                      <span>↩ Devolución por <span style={{ ...sx.mono, fontWeight: 600, color: colors.text }}>$ {fmtMonto(caso.importe)}</span></span>
                      <a style={{ color: colors.link, cursor: 'pointer', textDecoration: 'underline', fontWeight: 500 }}
                        onClick={() => navigate(`/casos/${caso.id}`)}>Ver el caso →</a>
                    </div>
                  )}
                  {(caso.reposicion_nota_venta || caso.reposicion_remito || caso.reposicion_nota_envio) && (
                    <div style={{ marginTop: 6, display: 'flex', gap: 10, flexWrap: 'wrap', fontSize: 12.5 }}>
                      {caso.reposicion_nota_venta && (
                        <a style={{ color: '#1d4ed8', cursor: 'pointer', textDecoration: 'underline' }}
                          onClick={() => navigate(`/notas-venta/${caso.reposicion_nota_venta.id}`)}>
                          NV {caso.reposicion_nota_venta.numero_lgr} ({caso.reposicion_nota_venta.estado})
                        </a>
                      )}
                      {caso.reposicion_nota_envio && (
                        <a style={{ color: '#1d4ed8', cursor: 'pointer', textDecoration: 'underline' }}
                          onClick={() => navigate(`/notas-envio/${caso.reposicion_nota_envio.id}`)}>
                          NE {caso.reposicion_nota_envio.numero_ne} ({caso.reposicion_nota_envio.estado})
                        </a>
                      )}
                      {caso.reposicion_remito && (
                        <a style={{ color: '#1d4ed8', cursor: 'pointer', textDecoration: 'underline' }}
                          onClick={() => navigate(`/logistica/remitos/${caso.reposicion_remito.id}`)}>
                          Remito {caso.reposicion_remito.numero_presea} ({caso.reposicion_remito.estado})
                        </a>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Avisos internos sobre este remito ("imprimilo y mandámelo"). */}
          <AvisosCard tipo="remito" id={remito.id} />

          {/* Historial estados */}
          <div style={st.card}>
            <h3 style={st.cardTitle}>Historial</h3>
            {(!remito.historial || remito.historial.length === 0) ? (
              <p style={st.hint}>Sin historial.</p>
            ) : (
              <div style={st.timeline}>
                {/* Línea de tiempo CRONOLÓGICA (lo primero arriba). El backend
                    devuelve descendente; invertimos para leer como una secuencia.
                    Mostramos solo el estado nuevo de cada paso: el anterior es
                    redundante (es el del paso previo) y mostrar "X→Y" hacía
                    parecer que el remito "volvía" un estado. Una fila cuyo
                    estado no cambia (ej. reimpresión) se marca como evento. */}
                {[...remito.historial].reverse().map((h, i, hist) => {
                  const esEvento = h.estado_anterior === h.estado_nuevo
                  return (
                    <div key={i} style={st.tlItem}>
                      <div style={st.tlMarker}>
                        <span style={st.tlDot} />
                        {i < hist.length - 1 && <span style={st.tlLine} />}
                      </div>
                      <div style={st.tlBody}>
                        <div style={st.historialEstados}>
                          {esEvento
                            ? <span style={st.tlEvento}>📄 Evento</span>
                            : <EstadoBadgeRemito estado={h.estado_nuevo} />}
                        </div>
                        <div style={st.historialMeta}>{fmtFechaHora(h.created_at)}</div>
                        {h.usuario && <div style={st.historialUser}>{h.usuario.nombre}</div>}
                        {h.motivo && <div style={st.historialMotivo}>{h.motivo}</div>}
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
          </div>

          {/* Observaciones (solo T90) */}
          {!es80 && (remito.observaciones_raw || remito.observaciones_parsed) && (
            <div style={st.card}>
              <h3 style={st.cardTitle}>Observaciones</h3>
              {remito.observaciones_raw && (
                <textarea
                  readOnly
                  value={remito.observaciones_raw}
                  style={st.obsTextarea}
                />
              )}
              {remito.observaciones_parsed && Object.keys(remito.observaciones_parsed).length > 0 && (
                <div style={{ marginTop: 8, fontSize: 12, color: '#475569' }}>
                  <strong style={{ color: '#0f172a' }}>Interpretado:</strong>
                  <pre style={st.obsPre}>{JSON.stringify(remito.observaciones_parsed, null, 2)}</pre>
                </div>
              )}
            </div>
          )}

        </div>
      </div>

      {imgModal && (
        <div onClick={() => setImgModal(null)} style={st.imgOverlay}>
          <img src={imgModal} alt="Foto" style={{ maxWidth: '90vw', maxHeight: '90vh', borderRadius: 8 }} />
        </div>
      )}
    </div>
  )
}

const st = {
  wrap: { maxWidth: 1100, margin: '0 auto', fontVariantNumeric: 'tabular-nums', paddingBottom: 24 },

  // Toolbar sticky superior — estado + acciones siempre visibles
  toolbar: {
    position: 'sticky', top: 0, zIndex: 10,
    display: 'flex', alignItems: 'center', gap: 12,
    padding: '12px 0', marginBottom: 16,
    background: '#fff', borderBottom: '1px solid #e2e8f0',
    boxShadow: '0 1px 0 #e2e8f0',
  },
  breadcrumb: { display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#64748b' },
  breadcrumbItem: { color: '#64748b' },
  breadcrumbSep: { color: '#cbd5e1' },
  breadcrumbNum: { fontFamily: FONT_MONO, color: '#0f172a', fontWeight: 500, fontSize: 13, background: '#f8fafc', padding: '2px 8px', borderRadius: 4 },
  toolbarSpacer: { flex: 1 },
  toolbarAcciones: { display: 'flex', gap: 6, flexWrap: 'wrap' },

  // Mensajes
  successBox: { background: '#dcfce7', color: '#166534', padding: '8px 12px', borderRadius: 6, marginBottom: 12, fontSize: 13, fontWeight: 500 },
  errorBox:   { background: '#fee2e2', color: '#991b1b', padding: '8px 12px', borderRadius: 6, marginBottom: 12, fontSize: 13 },
  bannerPendiente: { background: '#fef3c7', border: '1px solid #fcd34d', color: '#92400e', padding: '10px 14px', borderRadius: 8, marginBottom: 12, fontSize: 13, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' },

  anularBox: { background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 8, padding: 12, marginBottom: 12 },
  input: { padding: '6px 10px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 13, fontFamily: 'inherit' },
  error: { color: '#991b1b', fontSize: 12, marginTop: 6 },

  // Grid 2-col
  grid: { display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 16 },
  mainCol: { display: 'flex', flexDirection: 'column', gap: 16, minWidth: 0 },
  asideCol: { display: 'flex', flexDirection: 'column', gap: 16, minWidth: 0 },

  // Documento (ancla visual)
  documento: { background: '#fff', borderRadius: 10, border: '1px solid #e2e8f0', overflow: 'hidden' },
  docHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', padding: '20px 24px', borderBottom: '2px solid #0f172a', gap: 12, flexWrap: 'wrap' },
  docHeaderLeft: { display: 'flex', flexDirection: 'column', gap: 4 },
  docHeaderRight: { display: 'flex', gap: 6, alignItems: 'center' },
  docLabel: { fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em' },
  docNumero: { fontFamily: FONT_MONO, fontSize: 28, fontWeight: 600, color: '#0f172a', lineHeight: 1 },
  docCliente: { padding: '14px 24px', borderBottom: '1px solid #e2e8f0' },
  docClienteNombre: { fontSize: 16, fontWeight: 600, color: '#0f172a', marginBottom: 4 },
  docClienteDatos: { display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center', fontSize: 13, color: '#64748b' },
  docEntrega: { marginTop: 10, paddingTop: 10, borderTop: '1px dashed #e2e8f0' },
  docEntregaLabel: { fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4 },
  docEntregaDatos: { display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center', fontSize: 13, color: '#0f172a' },
  docMono: { fontFamily: FONT_MONO },
  docMetaSep: { color: '#cbd5e1' },
  docDetalle: { padding: '14px 24px 18px' },
  docTable: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  docThNum: { padding: '8px 6px', textAlign: 'center', borderBottom: '1px solid #0f172a', fontWeight: 600, fontSize: 11, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', width: 32 },
  docTh: { padding: '8px 8px', textAlign: 'left', borderBottom: '1px solid #0f172a', fontWeight: 600, fontSize: 11, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' },
  docTr: { borderBottom: '1px solid #f1f5f9' },
  docTd: { padding: '8px 8px', verticalAlign: 'middle', color: '#0f172a', fontSize: 13 },
  docTdNum: { padding: '8px 6px', textAlign: 'center', color: '#94a3b8', fontSize: 12, fontFamily: FONT_MONO },
  docTdCodigo: { padding: '8px 8px', verticalAlign: 'middle', fontFamily: FONT_MONO, fontSize: 13, fontWeight: 500, color: '#0f172a' },

  // Badges
  badge: { display: 'inline-block', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600, letterSpacing: '0.02em', textTransform: 'uppercase' },
  badgeT90: { background: '#eff6ff', color: '#1d4ed8' },
  badgeT80: { background: '#f5f3ff', color: '#6d28d9' },
  badgeZona: { display: 'inline-block', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 500, background: '#f1f5f9', color: '#475569' },

  // Cards
  card: { background: '#fff', borderRadius: 10, border: '1px solid #e2e8f0', padding: 16 },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, gap: 8, flexWrap: 'wrap' },
  cardTitle: { margin: '0 0 12px', fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' },
  hint: { color: '#94a3b8', fontSize: 13, margin: 0 },

  // Rows tipo label/value
  row: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '6px 0', borderBottom: '1px solid #f1f5f9', fontSize: 13, gap: 8 },
  rowLast: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '6px 0', fontSize: 13, gap: 8 },
  rowLabel: { color: '#64748b', fontSize: 12, flexShrink: 0 },
  rowValue: { color: '#0f172a', fontWeight: 500, textAlign: 'right', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' },
  rowMono: { fontFamily: FONT_MONO },
  rowLink: { background: 'none', border: 'none', color: '#1d4ed8', fontWeight: 500, cursor: 'pointer', fontSize: 13, textDecoration: 'underline', fontFamily: FONT_MONO, padding: 0 },

  // Comercial
  comercialBlock: { paddingTop: 8, marginTop: 8, borderTop: '1px solid #f1f5f9' },
  comercialBlockTitle: { fontSize: 11, fontWeight: 600, color: '#0f172a', marginBottom: 4 },
  pagoBox: { paddingBottom: 8, marginBottom: 8, borderBottom: '1px dashed #e2e8f0' },
  comercialTotal: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '8px 0 0', marginTop: 4, borderTop: '2px solid #0f172a' },

  // Historial estados
  historialList: { display: 'flex', flexDirection: 'column', gap: 8 },
  historialItem: { padding: '8px 0', borderBottom: '1px solid #f1f5f9' },
  historialEstados: { display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4, flexWrap: 'wrap' },
  historialFlecha: { color: '#cbd5e1', fontSize: 12 },

  // Timeline cronológico de estados (lo primero arriba, sin falsos retrocesos)
  timeline: { display: 'flex', flexDirection: 'column' },
  tlItem: { display: 'flex', gap: 10, alignItems: 'stretch' },
  tlMarker: { display: 'flex', flexDirection: 'column', alignItems: 'center', width: 14, flexShrink: 0 },
  tlDot: { width: 9, height: 9, borderRadius: '50%', background: '#1d4ed8', marginTop: 5, flexShrink: 0 },
  tlLine: { flex: 1, width: 2, background: '#e2e8f0', marginTop: 2 },
  tlBody: { paddingBottom: 12, flex: 1, minWidth: 0 },
  tlEvento: { fontSize: 11, fontWeight: 600, color: '#92400e', background: '#fef3c7', padding: '2px 8px', borderRadius: 4, textTransform: 'uppercase', letterSpacing: '0.02em' },
  historialMeta: { fontSize: 11, color: '#94a3b8', fontFamily: FONT_MONO },
  historialUser: { fontSize: 12, color: '#475569', marginTop: 2 },
  historialMotivo: { fontSize: 12, color: '#64748b', fontStyle: 'italic', marginTop: 2 },

  // NEs tabla
  neTable: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  neTh: { padding: '6px 8px', textAlign: 'left', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', fontWeight: 600, fontSize: 11, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap' },
  neTr: { borderBottom: '1px solid #f1f5f9' },
  neTd: { padding: '8px', verticalAlign: 'middle', fontSize: 13, color: '#0f172a' },
  neTdMono: { padding: '8px', verticalAlign: 'middle', fontSize: 13, color: '#0f172a', fontFamily: FONT_MONO, fontWeight: 500, whiteSpace: 'nowrap' },
  neTdSec: { padding: '8px', verticalAlign: 'middle', fontSize: 12, color: '#64748b', whiteSpace: 'nowrap' },
  neTdAcc: { padding: '8px', verticalAlign: 'middle', textAlign: 'right' },
  neDest: { fontSize: 13, fontWeight: 500, color: '#0f172a' },
  neDestSec: { fontSize: 11, color: '#94a3b8', marginTop: 1 },

  // Entregas
  entregaBox:   { border: '1px solid #e2e8f0', borderRadius: 8, padding: 12, marginBottom: 8 },
  entregaHeader:{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, flexWrap: 'wrap', gap: 8 },
  entregaTag:   { fontFamily: FONT_MONO, background: '#f8fafc', padding: '2px 7px', borderRadius: 4, fontSize: 12, fontWeight: 500, color: '#0f172a' },
  entregaDest:  { fontSize: 13, fontWeight: 500, color: '#0f172a' },
  entregaBadge: { padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600, letterSpacing: '0.02em', textTransform: 'uppercase' },
  entregaRow:   { display: 'flex', gap: 10, alignItems: 'center', marginTop: 6, fontSize: 13, flexWrap: 'wrap' },
  entregaLbl:   { fontSize: 11, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', minWidth: 78, flexShrink: 0 },
  entregaVal:   { color: '#0f172a', display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', fontSize: 13 },
  entregaChip:  { fontSize: 11, background: '#f8fafc', padding: '2px 8px', borderRadius: 6, color: '#475569' },
  entregaLink:  { background: 'none', border: 'none', color: '#1d4ed8', fontWeight: 500, cursor: 'pointer', fontSize: 12, textDecoration: 'underline' },
  entregaThumb: { width: 80, height: 80, objectFit: 'cover', borderRadius: 6, cursor: 'zoom-in', border: '1px solid #e2e8f0' },
  imgOverlay:   { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, cursor: 'zoom-out' },

  // Observaciones (solo T90)
  obsTextarea: { width: '100%', minHeight: 70, padding: '8px 10px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 12, background: '#f8fafc', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit', color: '#0f172a' },
  obsPre: { margin: '4px 0 0', padding: '8px 10px', background: '#f8fafc', borderRadius: 6, fontSize: 11, whiteSpace: 'pre-wrap', fontFamily: FONT_MONO },

  // Estados de pago
  estadoChip: { padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.02em' },
  estadoOk: { background: '#dcfce7', color: '#166534' },
  estadoPend: { background: '#fef3c7', color: '#92400e' },
  estadoMal: { background: '#fee2e2', color: '#991b1b' },
  noSuma: { fontSize: 11, color: '#991b1b', marginLeft: 6 },

  placeholder: { color: '#cbd5e1' },
}
